// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p1-0";
export var leftAlign = "_p1-4";
export var listItem = "_p1-2";
export var listItemWrapper = "_p1-1";
export var operationText = "_p1-3";